export default __webpack_public_path__ + "static/media/decagon.ac6cede1.svg";